module.exports = __webpack_public_path__ + "static/media/ps.27e77492.svg";